module.exports = __webpack_public_path__ + "117d9899255a2618c0dbceef22b545fb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-1.png
// module id = 2150
// module chunks = 0